<template>
  <div>
    <section class="p-4">
      <div class="flex flex-wrap">
        <div
          class="w-full lg:w-1/1 py-4 px-10 mb-4 bg-white rounded-lg shadow-xl"
        >
          <h3 class="text-2xl font-heading text-center">Timeplan</h3>
          <div class="flex justify-center ...">
            <ArrowCircleLeftIcon
              size="2.0x"
              class="mx-3"
              :class="{
                'text-gray-600': this.selectedDateEpoch == 0,
                'text-gray-900': this.selectedDateEpoch != 0,
              }"
              @click="previousDay"
            />
            <h3 class="text-md text-gray-600 leading-relaxed text-center">
              {{
                getDayOfEpoch(this.currentDateEpochs[this.selectedDateEpoch])
              }}
            </h3>
            <ArrowCircleRightIcon
              size="2.0x"
              class="mx-3"
              :class="{
                'text-gray-600':
                  this.selectedDateEpoch + 1 == this.currentDateEpochs.length,
                'text-gray-900':
                  this.selectedDateEpoch + 1 < this.currentDateEpochs.length,
              }"
              @click="nextDay"
            />
          </div>

          <div
            v-for="(item, index) in this.filteredEvents[
              this.currentDateEpochs[this.selectedDateEpoch]
            ]"
            :key="item.id"
          >
            <p class="text-md mt-4 text-gray-800 font-bold leading-relaxed">
              {{ item.time }} - {{ item.title }}
            </p>
            <p class="text-sm text-gray-600 leading-relaxed">
              Instruktør: {{ item.instructorName }}
            </p>
            <p class="text-xs text-grat-500 leading-relaxed">
              {{ item.description }}
            </p>
            <hr
              class="mt-4 mx-4"
              v-if="index != Object.keys(getCurrentDay).length - 1"
            />
          </div>
        </div>
        <!--<div
          class="flex-1 py-4 px-10 ml-0 lg:ml-4 mb-4 bg-white rounded-lg shadow-xl"
        >
          <h3 class="text-2xl font-heading">Neste 6 dagene</h3>
          <div class="flex flex-wrap">
            <div
              class="w-full md:w-1/2 lg:w-1/3 my-4 px-2"
              v-for="epoch in getOtherDays"
              :key="epoch"
            >
              <h3 class="text-xl font-heading text-center mb-4">
                {{ getDayOfEpoch(epoch) }}
              </h3>
              <p
                v-if="!department.schedule[epoch]"
                class="text-md text-center text-gray-800 font-bold leading-relaxed"
              >
                Ingen timer denne dagen
              </p>
              <div
                v-for="(item, index) in department.schedule[epoch]"
                :key="item.id"
              >
                <p class="text-md text-gray-800 font-bold leading-relaxed">
                  {{ item.time }} - {{ item.title }}
                </p>
                <hr
                  class="my-2 mx-4"
                  v-if="
                    index != Object.keys(department.schedule[epoch]).length - 1
                  "
                />
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </section>
  </div>
</template>

<script>
import { firebaseInstance } from "./firebase.js";
import moment from "moment";
import schedule from "node-schedule";
import {
  ArrowCircleLeftIcon,
  ArrowCircleRightIcon,
} from "@vue-hero-icons/outline";
import _ from "lodash";
moment.locale("nb");

const departments = firebaseInstance.firestore().collection("departments");

export default {
  components: {
    ArrowCircleLeftIcon,
    ArrowCircleRightIcon,
  },

  name: "Schedule",
  data() {
    return {
      currentDepartment: "3307",
      onlyBranches: null,
      excludeBranches: null,
      department: {},
      currentDateEpochs: [],
      selectedDateEpoch: null,
    };
  },

  computed: {
    getCurrentDay: function () {
      if (
        this.department &&
        this.department.schedule &&
        this.currentDateEpochs &&
        this.selectedDateEpoch
      ) {
        return this.department.schedule[
          this.currentDateEpochs[this.selectedDateEpoch]
        ];
      } else {
        return [];
      }
    },
    filteredEvents: function() {
      if(this.department && this.department.schedule) {
        if(this.onlyBranches || this.excludeBranches) {
          const filteredSchedule = _.mapValues(this.department.schedule, dayArray => {
            const filteredEvents = _.filter(dayArray, event => {
              if(this.onlyBranches) {
                return this.onlyBranches.includes(event.branchId.toString()); 
              } else if(this.excludeBranches) {
                return !this.excludeBranches.includes(event.branchId.toString());
              } else {
                return true;
              }
            });
            return filteredEvents;
          });
          return filteredSchedule;
        } else {
          return this.department.schedule;
        }
      } else {
        return {};
      }
    },
  },

  mounted() {
    if (this.$route.query.d) {
      this.currentDepartment = this.$route.query.d;
    }
    if (this.$route.query.only) {
      this.onlyBranches = this.$route.query.only.split(',');
    }
    if (this.$route.query.exclude) {
      this.excludeBranches = this.$route.query.exclude.split(',');
    }
    firebaseInstance.analytics();
    this.currentDateEpochs = this.getDateEpochs();
    this.selectedDateEpoch = 0;
    schedule.scheduleJob("* * * * *", () => {
      this.currentDateEpochs = this.getDateEpochs();
      this.selectedDateEpoch = 0;
    });
  },

  watch: {
    currentDepartment: {
      immediate: true,
      handler(id) {
        this.$bind("department", departments.doc(id));
      },
    },
  },

  methods: {
    getDateEpochs() {
      const currentDate = moment();
      var dateEpochs = [];
      for (var i = 0; i < 7; i++) {
        dateEpochs.push(
          moment(
            currentDate.add(i == 0 ? i : 1, "d").format("YYYY-MM-DD")
          ).unix()
        );
      }
      return dateEpochs;
    },

    getDayOfEpoch(epoch) {
      return moment.unix(epoch).format("dddd, Do MMMM");
    },

    nextDay() {
      if (this.selectedDateEpoch + 1 < this.currentDateEpochs.length) {
        this.selectedDateEpoch += 1;
      }
    },

    previousDay() {
      if (this.selectedDateEpoch > 0) {
        this.selectedDateEpoch -= 1;
      }
    },
  },
};
</script>

<style>
</style>
